import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton, PricePill } from './ui';
import { IMAGES } from './constants';
export function Hero() {
  return <section className="w-full bg-[#1B2B4A] px-6 py-16 sm:py-24" data-id="element-49">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 lg:order-1" data-id="element-51">
          <h1 className="font-serif text-4xl leading-tight text-white sm:text-5xl lg:text-6xl" data-id="element-52">
            ¿Tenés algo que te pesa y no sabés con quién hablarlo?
          </h1>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-white/70" data-id="element-53">
            EscuchaYA es un espacio privado, sin turnos ni esperas. Hablás
            cuando lo necesitás. Alguien que escucha de verdad.
          </p>
          <div className="mt-7" data-id="element-54">
            <PricePill data-id="element-55" />
          </div>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-56">
            <CtaButton variant="primary" data-id="element-57">Quiero hablar ahora →</CtaButton>
            <CtaButton variant="secondary" data-id="element-58">📅 Elegir mi turno →</CtaButton>
          </div>
          <p className="mt-6 text-sm text-white/60" data-id="element-59">
            Disponible ahora mismo · Pago seguro · Privacidad garantizada
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        ease: 'easeOut',
        delay: 0.15
      }} className="order-1 lg:order-2" data-id="element-60">
          <div className="overflow-hidden rounded-3xl border border-[#8BA3C7]/20" data-id="element-61">
            <img src={IMAGES.hero} alt="Persona en una llamada telefónica, en calma" className="h-full w-full object-cover" data-id="element-62" />
          </div>
        </motion.div>
      </div>
    </section>;
}